/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import useStoreState from 'lib/useStoreState';

export default (): Element<string> => {
  const { numProjects } = useStoreState({
    numProjects: 'projects.numProjects',
  });
  const num = numProjects || 0;
  return (
    <div
      className="project-count"
      css={css(`
      background: transparent;
      text-align: right;
      padding: 0;
      color: #666;
    `)}
    >
      <p>Showing {num} dots.</p>
      {num >= 1000 && (
        <p style={{ width: 115 }} className="text-danger">
          Limit reached.
        </p>
      )}
    </div>
  );
};
